import {
  Badge,
  BlockStack,
  Box,
  Card,
  InlineStack,
  Text,
  ChoiceList,
  Checkbox,
} from "@shopify/polaris";
import React from "react";
import "./index.css";
const Index = ({ pageData, setPageData }) => {
  return (
    <Box>
      <Card>
        <BlockStack gap={400}>
          <Box>
            <Text variant="headingSm" as="h6">
              List product setting
            </Text>
            <Text as="p" tone="subdued">
            Configure products published to your Shopify store
            </Text>
          </Box>
          <Box>
            <Box className="new_person_product_box">
              <BlockStack gap={200}>
                <Box>
                  <InlineStack gap={200}>
                    <Box className="list_as_product">
                      <InlineStack
                        align="space-between"
                        blockAlign="center"
                        wrap={false}
                      >
                        <Box className="list_as_product_left">
                          <Box className="list_as_product_left_title">
                            List as Active Product
                          </Box>
                          <Box className="list_as_product_left_content">
                            <InlineStack gap={200}>
                              <p>In product status show</p>
                              <Badge tone="success">Active</Badge>
                            </InlineStack>
                          </Box>
                        </Box>
                        <Box className="list_as_product_right">
                          <ChoiceList
                            choices={[{ label: "", value: 1 }]}
                            selected={[
                              pageData?.list_product_setting?.auto_publish,
                            ]}
                            onChange={(val) => {
                              setPageData((prev) => ({
                                ...prev,
                                list_product_setting: {
                                  ...prev.list_product_setting,
                                  auto_publish: val[0],
                                },
                              }));
                            }}
                          />
                        </Box>
                      </InlineStack>
                    </Box>
                    <Box className="list_as_product">
                      <InlineStack
                        align="space-between"
                        blockAlign="center"
                        wrap={false}
                      >
                        <Box className="list_as_product_left">
                          <Box className="list_as_product_left_title">
                            List as Draft Product
                          </Box>
                          <Box className="list_as_product_left_content">
                            <InlineStack gap={200}>
                              <p>In product status show</p>
                              <Badge tone="info">Draft</Badge>
                            </InlineStack>
                          </Box>
                        </Box>
                        <Box className="list_as_product_right">
                          <ChoiceList
                            choices={[{ label: "", value: 0 }]}
                            selected={[
                              pageData?.list_product_setting?.auto_publish,
                            ]}
                            onChange={(val) => {
                              setPageData((prev) => ({
                                ...prev,
                                list_product_setting: {
                                  ...prev.list_product_setting,
                                  auto_publish: val[0],
                                },
                              }));
                            }}
                          />
                        </Box>
                      </InlineStack>
                    </Box>
                  </InlineStack>
                </Box>

                <Box>
                  <InlineStack blockAlign="center" wrap={false}>
                    <Checkbox
                      checked={
                        pageData?.list_product_setting?.set_product_taxable
                      }
                      onChange={(val) => {
                        setPageData((prev) => ({
                          ...prev,
                          list_product_setting: {
                            ...prev.list_product_setting,
                            set_product_taxable: val ? 1 : 0,
                          },
                        }));
                      }}
                    />
                    <p>Set products as taxable</p>
                  </InlineStack>
                  <Box style={{ marginLeft: "26px" }}>
                    <Text as="span" tone="subdued">
                      Specifies whether or not a tax is charged when the product
                      variant is sold
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <InlineStack blockAlign="center" wrap={false}>
                    <Checkbox
                      checked={pageData?.list_product_setting?.continue_selling}
                      onChange={(val) => {
                        setPageData((prev) => ({
                          ...prev,
                          list_product_setting: {
                            ...prev.list_product_setting,
                            continue_selling: val ? 1 : 0,
                          },
                        }));
                      }}
                    />
                    <p>Continue selling even when products are out of stock.</p>
                  </InlineStack>
                  <Box style={{ marginLeft: "26px" }}>
                    <Text as="span" tone="subdued">
                      Customers can order even when products are out of stock on
                      your website.
                    </Text>
                  </Box>
                </Box>
              </BlockStack>
            </Box>
          </Box>
        </BlockStack>
      </Card>
    </Box>
  );
};

export default Index;
